import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { SCENE_ANIMATION } from '../constants';

export const useAnimatedText = () => {
  const textRef = useRef();

  useFrame((state) => {
    if (!textRef.current) return;
    
    const time = state.clock.elapsedTime;
    const { ROTATION_Y, POSITION_Y, ROTATION_X } = SCENE_ANIMATION;
    
    textRef.current.rotation.y = 
      Math.sin(time * ROTATION_Y.FREQUENCY_1) * ROTATION_Y.AMPLITUDE_1 + 
      Math.sin(time * ROTATION_Y.FREQUENCY_2) * ROTATION_Y.AMPLITUDE_2 + 
      Math.cos(time * ROTATION_Y.FREQUENCY_3) * ROTATION_Y.AMPLITUDE_3;
    
    textRef.current.position.y = 
      Math.sin(time * POSITION_Y.FREQUENCY_1) * POSITION_Y.AMPLITUDE_1 + 
      Math.cos(time * POSITION_Y.FREQUENCY_2) * POSITION_Y.AMPLITUDE_2 + 
      Math.sin(time * POSITION_Y.FREQUENCY_3) * POSITION_Y.AMPLITUDE_3;
    
    textRef.current.rotation.x = 
      Math.sin(time * ROTATION_X.FREQUENCY_1) * ROTATION_X.AMPLITUDE_1 + 
      Math.cos(time * ROTATION_X.FREQUENCY_2) * ROTATION_X.AMPLITUDE_2;
  });

  return textRef;
};

